import { Tuple } from '../../../types';
import { matchAlphanumericExtended, maxLength } from '../../validationFunctions';
import * as validatorRules from '../../validatorRules.json';
import { interpolateValidationRule } from '../../validatorMessages';

export const referenceDescriptionValidator: Tuple<(value: any) => boolean, string>[] = [
    [maxLength(250), interpolateValidationRule(validatorRules.BR3_Maximum_Field_Length, [], ['250'])],
    [matchAlphanumericExtended, interpolateValidationRule(validatorRules.BR12_AlphaNumeric_Extended, [['PropertyName', `Project reference description`]], [])],
];
